import epsClient from 'enrollment-platform/api/eps.client'
import type {
  SmokerRateLevelHistoryQueryDto,
  PaginatedSmokerRateLevelHistoryResponseDto,
} from './dto/smoker-rate-level-history.dto'
import type {
  BulkDeleteSmokerRateOverrideRulesRequestDto,
  BulkUpdateSmokerRateStatusByIdsRequestDto,
  CheckDuplicateSmokerRateOverrideRuleQueryDto,
  CheckDuplicateSmokerRateOverrideRuleResponseDto,
  CreatePlanSmokerRateOverrideRuleRequestDto,
  DeleteSmokerRateOverrideRulesByFilterRequestDto,
  DeleteSmokerRateOverrideRulesByFilterResponseDto,
  ListPlanSmokerRateOverrideRulesQueryDto,
  ListPlanSmokerRateOverrideRulesResponseDto,
  PlanSmokerRateOverrideRuleResponseDto,
  UpdateSmokerRateStatusByFilterBodyDto,
  UpdateSmokerRateStatusByFilterQueryDto,
  UpdateSmokerRateStatusByFilterResponseDto,
  UpdatePlanSmokerRateOverrideRuleRequestDto,
  UpdatePlanSmokerRateOverrideRuleStatusRequestDto,
} from './dto/plan-smoker-rate-override-rules.dto'

export const SMOKER_RATE_OVERRIDE_RULE_BASE =
  '/api/v1/plan-smoker-rate-override-rules'

export const listSmokerRateOverrideRules = async (
  params: ListPlanSmokerRateOverrideRulesQueryDto
): Promise<ListPlanSmokerRateOverrideRulesResponseDto> => {
  const { data } =
    await epsClient.get<ListPlanSmokerRateOverrideRulesResponseDto>(
      SMOKER_RATE_OVERRIDE_RULE_BASE,
      { params }
    )
  return data
}

export const getSmokerRateOverrideRule = async (
  id: string
): Promise<PlanSmokerRateOverrideRuleResponseDto> => {
  const { data } = await epsClient.get<PlanSmokerRateOverrideRuleResponseDto>(
    `${SMOKER_RATE_OVERRIDE_RULE_BASE}/${id}`
  )
  return data
}

export const createSmokerRateOverrideRule = async (
  body: CreatePlanSmokerRateOverrideRuleRequestDto
): Promise<PlanSmokerRateOverrideRuleResponseDto> => {
  const { data } = await epsClient.post<PlanSmokerRateOverrideRuleResponseDto>(
    SMOKER_RATE_OVERRIDE_RULE_BASE,
    body
  )
  return data
}

export const updateSmokerRateOverrideRule = async (
  id: string,
  body: UpdatePlanSmokerRateOverrideRuleRequestDto
): Promise<PlanSmokerRateOverrideRuleResponseDto> => {
  const { data } = await epsClient.patch<PlanSmokerRateOverrideRuleResponseDto>(
    `${SMOKER_RATE_OVERRIDE_RULE_BASE}/${id}`,
    body
  )
  return data
}

export const checkDuplicateSmokerRateOverrideRule = async (
  query: CheckDuplicateSmokerRateOverrideRuleQueryDto
): Promise<CheckDuplicateSmokerRateOverrideRuleResponseDto> => {
  const { data } =
    await epsClient.get<CheckDuplicateSmokerRateOverrideRuleResponseDto>(
      `${SMOKER_RATE_OVERRIDE_RULE_BASE}/check-duplicate`,
      { params: query }
    )
  return data
}

export const updateSmokerRateOverrideRuleStatus = async (
  id: string,
  body: UpdatePlanSmokerRateOverrideRuleStatusRequestDto
): Promise<PlanSmokerRateOverrideRuleResponseDto> => {
  const { data } = await epsClient.patch<PlanSmokerRateOverrideRuleResponseDto>(
    `${SMOKER_RATE_OVERRIDE_RULE_BASE}/${id}/status`,
    body
  )
  return data
}

export const deleteSmokerRateOverrideRule = async (
  id: string
): Promise<void> => {
  await epsClient.delete(`${SMOKER_RATE_OVERRIDE_RULE_BASE}/${id}`)
}

export const bulkDeleteSmokerRateOverrideRules = async (
  body: BulkDeleteSmokerRateOverrideRulesRequestDto
): Promise<void> => {
  await epsClient.delete(`${SMOKER_RATE_OVERRIDE_RULE_BASE}/bulk`, {
    data: body,
  })
}

export const deleteSmokerRateOverrideRulesByFilter = async (
  params: DeleteSmokerRateOverrideRulesByFilterRequestDto
): Promise<DeleteSmokerRateOverrideRulesByFilterResponseDto> => {
  const { data } = await epsClient.delete(SMOKER_RATE_OVERRIDE_RULE_BASE, {
    params,
  })
  return data as DeleteSmokerRateOverrideRulesByFilterResponseDto
}

export const bulkUpdateSmokerRateStatusByIds = async (
  body: BulkUpdateSmokerRateStatusByIdsRequestDto
): Promise<void> => {
  await epsClient.patch(`${SMOKER_RATE_OVERRIDE_RULE_BASE}/bulk/status`, body)
}

export const updateSmokerRateStatusByFilter = async (
  query: UpdateSmokerRateStatusByFilterQueryDto,
  body: UpdateSmokerRateStatusByFilterBodyDto
): Promise<UpdateSmokerRateStatusByFilterResponseDto> => {
  const { data } =
    await epsClient.patch<UpdateSmokerRateStatusByFilterResponseDto>(
      `${SMOKER_RATE_OVERRIDE_RULE_BASE}/status`,
      body,
      { params: query }
    )
  return data
}

export const listSmokerRateLevelHistory = async (
  params: SmokerRateLevelHistoryQueryDto
): Promise<PaginatedSmokerRateLevelHistoryResponseDto> => {
  const { data } =
    await epsClient.get<PaginatedSmokerRateLevelHistoryResponseDto>(
      `${SMOKER_RATE_OVERRIDE_RULE_BASE}/history`,
      { params }
    )
  return data
}
